module.exports = __webpack_public_path__ + "media/images/icons/recruitment-chat-5d48c976c39b89cbc2c7dae204b91128.svg";